module.exports = __webpack_public_path__ + "static/media/edit-lock-button.2a507606.svg";